module.exports = __webpack_public_path__ + "img/moular1.9cb73037.png";